import { Component, OnInit, Input } from "@angular/core";
import { InventoryItem, InventoryService } from "@rubbl-inventory";
import { ListDropdownGroupItem, ListGroupItem } from "@rubbl-shared";

@Component({
  selector: "app-machine-specs",
  templateUrl: "./machine-specs.component.html",
  styleUrls: ["./machine-specs.component.scss"],
})
export class MachineSpecsComponent implements OnInit {
  @Input() machine: InventoryItem;
  listGroupItems: ListDropdownGroupItem[] = [];

  constructor(private inventoryService: InventoryService) {}

  ngOnInit() {
    this.inventoryService.getSpecs(this.machine.id, this.machine.accountId).subscribe(specifications => {
      this.listGroupItems = specifications
        .filter(spec => spec.name != null && spec.name != "") // filter out specs that do not have a name
        .map(specifications => {
          const item = new ListDropdownGroupItem();
          item.header = specifications.name;
          item.toggled = true;
          item.dropdownItems = specifications.items.map(items => {
            const groupItem = new ListGroupItem();
            groupItem.leftText = items.name || items.key;
            groupItem.rightText = items.value;
            return groupItem;
          });
          return item;
        });
    });
  }
}
